import { Item } from "@radix-ui/react-context-menu";

import { item } from "../../css/menu";
import { styled } from "../../theme/stitches";

export const ContextMenuItem = styled(Item, item);
